import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './../common.css';
import {Modal} from 'react-bootstrap';
import axios from "axios";
import {store} from "react-notifications-component";
import Constants from "../constants";

class DialogCreateProject extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: props.show,
            title: '',
            path: ''
        }

        this.hide = this.hide.bind(this);
        this.createProject = this.createProject.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handlePathChange = this.handlePathChange.bind(this);
    }

    hide() {
        this.props.onClose();
    }

    createProject() {
        const notificationError = {
            title: 'Error',
            message: 'Unable to create project "' + this.state.title + '"',
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        }
        const notificationException = {
            ...notificationError,
            message: 'Error occured while creating project. Try again'
        }
        const notificationSuccess = {
            ...notificationError,
            title: 'Success',
            message: 'Project ' + this.state.title + ' successfully created',
            type: 'success'
        }
        const url = Constants.BASE_URL + 'projects/create'
        const body = {
            'title': this.state.title,
            'path': this.state.path
        }
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }
        axios.post(url, body, config)
            .then(response => {
                    if (response.data.status === 'success') {
                        this.props.onCreate();
                        store.addNotification(notificationSuccess)
                        this.hide();
                    } else {
                        store.addNotification(notificationError)
                    }
                }
            )
            .catch(() => {
                store.addNotification(notificationException)
            })
    }

    handleTitleChange(event) {
        this.setState({
            title: event.target.value
        });
    }

    handlePathChange(event) {
        this.setState({
            path: event.target.value
        });
    }

    render() {
        return (
            <Modal show={this.state.show} onHide={this.hide}>
                <Modal.Header>
                    <Modal.Title>Create new project</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <input type='text' className='form-control' placeholder='Project title'
                           onChange={this.handleTitleChange}/>
                    &emsp;
                    <input type='text' className='form-control' placeholder='Project path'
                           onChange={this.handlePathChange}/>
                </Modal.Body>

                <Modal.Footer>
                    <button className='btn btn-outline-secondary' onClick={this.hide}>Cancel</button>
                    <button className='btn btn-success' onClick={this.createProject}
                            disabled={this.state.title === '' || this.state.path === ''}>Save
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

}

export default DialogCreateProject;